import React from "react";
import { FaInstagram, FaTiktok, FaFacebook, FaWhatsapp } from "react-icons/fa";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
     <footer className="bg-black text-white pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">

        {/* === Logo & Descripción === */}
        <div>
          <h2 className="text-3xl font-extrabold mb-4 tracking-wider text-[#d24e1e]">
            AdAstra
          </h2>
          <p className="text-gray-300 leading-relaxed text-sm">
            Suplementos Naturales Premium creados con ingredientes de alta calidad,
            diseñados para potenciar tu bienestar, energía y rendimiento diario.
          </p>
        </div>

        {/* === Enlaces rápidos === */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-[#d24e1e]">Enlaces</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li>
              <a href="/" className="hover:text-white transition">Inicio</a>
            </li>
            <li>
              <a href="/productos" className="hover:text-white transition">Productos</a>
            </li>
            <li>
              <a href="/nosotros" className="hover:text-white transition">Nosotros</a>
            </li>
            <li>
              <a href="/contacto" className="hover:text-white transition">Contacto</a>
            </li>
            <li>
              <a href="/privacypolicy" className="hover:text-white transition">Política de Privacidad</a>
            </li>
            <li>
              <a href="/terminos" className="hover:text-white transition">Términos y Condiciones</a>
            </li>
          </ul>
        </div>

        {/* === Contacto === */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-[#d24e1e]">Contáctanos</h3>
          <ul className="space-y-3 text-sm text-gray-300">
            <li className="flex items-center gap-2">
              <MapPin size={16} className="text-[#d24e1e]" />
              <span>San José, Costa Rica</span>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={16} className="text-[#d24e1e]" />
              <a href="tel:+50660000000" className="hover:text-white transition">
                +506 8893-5779
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail size={16} className="text-[#d24e1e]" />
              <a href="mailto:info@adastra.cr" className="hover:text-white transition">
                info@adastracr.com
              </a>
            </li>
          </ul>
        </div>

        {/* === Redes Sociales === */}
        <div>
          <h3 className="text-lg font-semibold mb-4 text-[#d24e1e]">Síguenos</h3>
          <div className="flex items-center gap-4 text-2xl">
            <a
              href="https://www.instagram.com/adastra.cr"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#d24e1e] transition"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.tiktok.com/@adastracr"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#d24e1e] transition"
            >
              <FaTiktok />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61582789582226"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#d24e1e] transition"
            >
              <FaFacebook />
            </a>
            <a
              href="https://wa.me/50688935779"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#d24e1e] transition"
            >
              <FaWhatsapp />
            </a>
          </div>

          {/* Newsletter */}
          <form className="mt-6">
            <label htmlFor="email" className="block text-sm text-gray-400 mb-2">
              Suscribite para recibir ofertas exclusivas:
            </label>
            <div className="flex">
              <input
                type="email"
                id="email"
                placeholder="Tu correo electrónico"
                className="w-full px-3 py-2 rounded-l-md text-gray-900 focus:outline-none"
              />
              <button
                type="submit"
                className="bg-[#d24e1e] text-black font-semibold px-4 py-2 rounded-r-md hover:bg-[#f3c44a] transition"
              >
                Enviar
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* === Línea inferior === */}
      <div className="border-t border-gray-800 mt-12 pt-6 text-center text-sm text-gray-400">
        <p>
          © {new Date().getFullYear()} AdAstra. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}